<div class="student-dashboard">
  <div class="side-nav">
    <div class="title">Welcome home!</div>
    <div class="logo">
      <div class="icon">
        <i class="fa-solid fa-user" *ngIf="!userDetails?.photo"></i>
        <img *ngIf="userDetails?.photo" [src]="
            getImage('data:image/jpeg;base64,' + userDetails?.photo.buffer)
          " alt="" />
      </div>
    </div>
    <div class="user-name">
      {{ userDetails?.firstName }} {{ userDetails?.lastName }}
    </div>
    <div class="tabs">
      <div class="label" [ngClass]="{ 'active-tab': selectedTab == 'dashboard' }" (click)="onSelectTab('dashboard')">
        Dashboard
      </div>
      <div class="label" [ngClass]="{ 'active-tab': selectedTab == 'account' }" (click)="onSelectTab('account')">
        My Account
      </div>
      <div class="label" [ngClass]="{ 'active-tab': selectedTab == 'scores' }" (click)="onSelectTab('scores')">
        My Scores
      </div>
      <div class="label" [ngClass]="{ 'active-tab': selectedTab == 'settings' }" (click)="onSelectTab('settings')">
        Settings
      </div>
      <div class="label" [ngClass]="{ 'active-tab': selectedTab == 'subsciption' }"
        (click)="onSelectTab('subsciption')">
        Subscription
      </div>
    </div>
  </div>
  <div class="content" *ngIf="selectedTab == 'dashboard'">
    <div class="course-empty-msg" *ngIf="myCourses.length === 0">
      No Courses Purchased!
    </div>
    <div class="top">
      <div class="selected-course-lessons" *ngIf="selectedCourse && !isEmptyObject(selectedCourse)">
        <div class="label">Jump right back...</div>
        <div class="lessons">
          <div class="lesson">
            <div class="title">
              {{ selectedCourse?.lastPlayedLesson?.title }}
            </div>
            <!-- <div class="name">name</div> -->
            <div class="video" (click)="onClickVideo(selectedCourse)">
              <span class="video-link">Click here to go to course!</span>
              <video id="videoPlayer" width="300px" playsinline style="pointer-events: none" controls [src]="
                  apiURL +
                  '/api/course/' +
                  selectedCourse?.course?.courseId._id +
                  '/module/' +
                  selectedCourse?.lastPlayedModule?._id +
                  '/lesson/' +
                  selectedCourse?.lastPlayedLesson?._id +
                  '/video/' +
                  selectedCourse?.lastPlayedLesson?.video
                " type="video/mp4"></video>
            </div>
          </div>
        </div>
      </div>
      <div class="my-courses" *ngIf="myCourses.length !== 0">
        <div class="title">My Courses</div>
        <div class="courses">
          <div class="course" [ngClass]="{
              'active-course':
                course?.courseId?._id === selectedCourse?.course?.courseId?._id
            }" *ngFor="let course of myCourses; let i = index" (click)="onClickMyCourse(course)">
            <div class="left">
              <div class="icon">
                <i class="fa-solid fa-circle-check"></i>
              </div>
            </div>
            <div class="right">
              <div class="label">Course {{ i + 1 }}</div>
              <div class="name">{{ course.courseId.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <!-- <div class="suggested-courses" *ngIf="suggestedCourses.length">
        <div class="title">Suggested Courses</div>
        <div class="scrollable-courses">
          <div
            class="left-arrow"
            (click)="scrollLeft()"
            *ngIf="suggestedCourses.length > 3"
          >
            <i class="fa-solid fa-angle-left"></i>
          </div>
          <div #courses class="courses">
            <div
              class="course"
              *ngFor="let course of suggestedCourses; let i = index"
              (click)="onClickSuggestedCourse(course)"
            >
              <div class="thumbnail">
                <img
                  [src]="
                    getImage(
                      'data:image/jpeg;base64,' + course.thumbnail.buffer
                    )
                  "
                  alt=""
                />
              </div>
              <div class="title-section">
                <div class="left">
                  <div class="name">{{ course.title }}</div>
                  <div class="duration">duration</div>
                </div>
                <div class="right">
                  <button>Know More</button>
                </div>
              </div>
              <div class="description">
                {{ course.description }}
              </div>
            </div>
          </div>
          <div
            class="right-arrow"
            (click)="scrollRight()"
            *ngIf="suggestedCourses.length > 3"
          >
            <i class="fa-solid fa-angle-right"></i>
          </div>
        </div>
      </div> -->
      <!-- <div class="upcoming-events">
        <div class="label">Upcoming Events</div>
      </div> -->
    </div>
  </div>
  <div class="user-tabs" *ngIf="selectedTab == 'account'">
    <app-account (selectedTab)="onSelectTab($event)"></app-account>
  </div>
  <div class="user-tabs" *ngIf="selectedTab == 'scores'">
    <app-scores (selectedTab)="onSelectTab($event)"></app-scores>
  </div>
  <div class="user-tabs" *ngIf="selectedTab == 'settings'">
    <app-settings (selectedTab)="onSelectTab($event)"></app-settings>
  </div>
  <div class="user-tabs" *ngIf="selectedTab == 'courses'">
    <app-my-courses (selectedTab)="onSelectTab($event)"></app-my-courses>
  </div>
  <div class="user-tabs" *ngIf="selectedTab == 'subsciption'">

    <div class="subscription-info" *ngIf="subscriptionRecord && subscriptionRecord.status == 'INACTIVE'">
      <div class="message">Your payment in being processed, please refresh this page after sometime.!</div>
      <div class="start-date">
        Payment Processed Date: {{ subscriptionRecord.modified_date | date:'dd MMM yyyy' }}
      </div>
    </div>

    <div class="subscription-info" *ngIf="subscriptionRecord && subscriptionRecord.status == 'ACTIVE'">
      <div class="message">Already a pro member!</div>
      <div class="start-date">
        Start Date: {{ subscriptionRecord.start_date | date:'dd MMM yyyy' }}
      </div>
      <div class="next-renewal-date">
        Next Renewal Date: {{ subscriptionRecord.next_renewal_date | date:'dd MMM yyyy' }}
      </div>
      <div class="btn">
        <button (click)="onClickStopRenewal()">Stop Auto Renewal</button>
      </div>
    </div>

    <div class="subscription-info"
      *ngIf="subscriptionRecord?.status == 'CANCELLED' || subscriptionRecord?.status == 'CANCEL_INITIATED'">
      <div class="message">You have cancelled your subscription, please renew below.</div>
      <div class="start-date">
        Cancellation Date: {{ subscriptionRecord?.cancellation?.event_date | date:'dd MMM yyyy' }}
      </div>
      <div class="btn">
        <button (click)="onClickReactivateSubscription()">Reactivate Subscription</button>
      </div>
    </div>

    <div class="subscription-info" *ngIf="!subscriptionRecord">
      <div class="message">You are a standard member, please enroll below. </div>
      <div class="btn">
        <button (click)="onClickReactivateSubscription()">Enroll Subscription</button>
      </div>
    </div>

    <!-- <div class="message" *ngIf="userDetails?.subscription.subscriptionStatus === 'Rejected'">
      Membership Rejected! Contact Admin.
    </div> -->

    <div class="message" *ngIf="userDetails?.subscription.subscriptionStatus === 'Pending'">
      Membership Approval Pending
    </div>

    <div class="message" *ngIf="userDetails?.subscription.subscriptionStatus === 'Expired'">
      <div class="head">Membership Expired! Pay for Membership Renewal!</div>
    </div>

    <div class="payment" *ngIf="userDetails?.subscription.subscriptionType === 'STANDARD' &&
           userDetails?.subscription.subscriptionStatus === 'None'">
      <div class="head">Pay for Membership Upgrade!</div>
      <app-payment [paymentForSubscription]="true" (paymentVerified)="isPaymentVerified()"></app-payment>
    </div>

  </div>
</div>

<div class="stop-renewal-overlay" *ngIf="showStopRenewalPopup" (click)="closeStopRenewalPopup()">
  <div class="stop-renewal-modal" (click)="$event.stopPropagation()">
    <div class="title">Stop Renewal</div>
    <div class="subtitle">
      Let us know why you’re stopping renewal.
    </div>

    <div class="field">
      <label>Reason</label>
      <select [(ngModel)]="stopRenewalReason">
        <option *ngFor="let reason of rejectionCodes" [value]="reason">
          {{ formatRenewalReason(reason) | titlecase }}
        </option>
      </select>
    </div>

    <div class="field">
      <label>Additional Feedback</label>
      <textarea rows="4" [(ngModel)]="stopRenewalFeedback" placeholder="Tell us more..."></textarea>
    </div>

    <div class="actions">
      <button class="secondary-btn" (click)="closeStopRenewalPopup()">
        Cancel
      </button>
      <button class="primary-btn" (click)="confirmStopRenewal()">
        Confirm
      </button>
    </div>
  </div>
</div>